import { AbstractControlOptions, AsyncValidatorFn, FormControl, ValidatorFn } from '@angular/forms';
import { findValueInObject } from '../../util/find-value-in-object';

export class FormControlRemote extends FormControl {

  private valuePath: string;

  constructor(valuePath: string,
              formState?: any,
              validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
              asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null) {
    super(formState, validatorOrOpts, asyncValidator);

    this.valuePath = valuePath;
  }


  setValue(value: any, options?: {
    onlySelf?: boolean;
    emitEvent?: boolean;
    emitModelToViewChange?: boolean;
    emitViewToModelChange?: boolean;
  }): void {
    if (this.valuePath && typeof value === 'object') {
      value = findValueInObject([ this.valuePath ], value);
    }

    super.setValue(value, options);
  }
}
